import _ from 'lodash';
// import moment from 'moment';
import getErrors from '../../../../shared/lib/geterrors';
import CollaboratoreService from '../../../../shared/services/api/collaboratore';
import { mapToCollaboratoreInitialValues } from './initialValues';


export const onCollaboratoreSubmit = (
  values,
  { setSubmitting, setErrors, setValues },
  { anagraficaId, update, notifications }
) => {
  const payload = {
    ...values,
    anagrafica: anagraficaId,
    profili: values.profili.map((profilo) =>
      ({
        id: profilo.id ? profilo.id : '',
        agenziakiron: profilo.agenziakiron ? profilo.agenziakiron.value : '',
        dataInizioValidita: profilo.dataInizioValidita ? +profilo.dataInizioValidita.format('X') : '',
        dataFineValidita: profilo.dataFineValidita ? +profilo.dataFineValidita.format('X') : '',
        gruppo: profilo.gruppo ? profilo.gruppo.value : '',
        tipoProfiloCollaboratore: profilo.tipoProfiloCollaboratore ? profilo.tipoProfiloCollaboratore.value : '',
        // createdAt: profilo.createdAt ? profilo.createdAt : '',
      })
    ),
    contratti: values.contratti.map(
      (contratto) => ({
        ...contratto,
        dataDecorrenza: contratto.dataDecorrenza ? +contratto.dataDecorrenza.format('X') : '',
        dataRescissione: contratto.dataRescissione ? +contratto.dataRescissione.format('X') : '',
      })
    ),
    enasarcoDataCessazione: values.enasarcoDataCessazione ? +values.enasarcoDataCessazione.format('X') : '',
    enasarcoDataIscrizione: values.enasarcoDataIscrizione ? +values.enasarcoDataIscrizione.format('X') : '',
  };

  if (!values.id || values.id.length === 0) {
    CollaboratoreService.create(payload)
    .then((data) => {
      setSubmitting(false);

      // Update form values if needed
      setValues({ ...values, id: data.id });

      // Success notification
      notifications.addNotification({
        message: 'Dati collaboratore salvati',
        level: 'success',
      });

      // Update parent list
      update();
    })
    .catch((errors) => {
      const errorsObj = getErrors(errors);
      setSubmitting(false);
      setErrors(errorsObj);

      // Error notification
      notifications.addNotification({
        message: 'Si è verificato un problema con il salvataggio del collaboratore, ricontrolla i campi inseriti',
        level: 'error',
      });
    });
  } else {
    CollaboratoreService.put(payload)
      .then(() => {
        setSubmitting(false);

        /* update dataFineValidità */
        /* const oldProfili = _.cloneDeep(values.profili);
        const newProfili = _.cloneDeep(data._embedded.profili);

        _.forEach(newProfili, (profilo) => {
          const matchIndex = _.findKey(oldProfili, (p) => p.id === profilo.id);
          if (matchIndex) {
            oldProfili[matchIndex].attivo = profilo.attivo;
            oldProfili[matchIndex].dataFineValidita = profilo.dataFineValidita ? moment.unix(profilo.dataFineValidita) : '';
            oldProfili[matchIndex].id = profilo.id;
          }
        });*/

        CollaboratoreService.getWithProfiliAndContratti(values.id).then(
          (updatedCollaboratore) => {
            const collaboratore = mapToCollaboratoreInitialValues(updatedCollaboratore);
            const profili = collaboratore.profili.map((profilo) => {
              const cleanedProfilo = _.cloneDeep(profilo);
              delete cleanedProfilo.createdAt;
              return cleanedProfilo;
            });

            collaboratore.profili = profili;

            setValues(collaboratore);
            update();
            notifications.addNotification({
              message: 'Dati collaboratore aggiornati',
              level: 'success',
            });
          });
      })
      .catch((errors) => {
        // console.log("ERRORS", errors);
        const errorsObj = getErrors(errors);
        setErrors(errorsObj);

        CollaboratoreService.getWithProfiliAndContratti(values.id).then(
          (updatedCollaboratore) => {
            const collaboratore = mapToCollaboratoreInitialValues(updatedCollaboratore);
            const profili = collaboratore.profili.map((profilo) => {
              const cleanedProfilo = _.cloneDeep(profilo);
              delete cleanedProfilo.createdAt;
              return cleanedProfilo;
            });

            collaboratore.profili = profili;

            setValues(collaboratore);
            setSubmitting(false);
          });

        // Error notification
        notifications.addNotification({
          message: _.get(errors, 'data.detail') || 'Si è verificato un problema con il salvataggio del collaboratore, ricontrolla i campi inseriti',
          level: 'error',
        });
      });
  }
};

export default onCollaboratoreSubmit;



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/Collaboratore/submit.js